<template>
  <!-- Modal -->
  <div v-if="this.$store.state.modal.planilhasPreventivas.show === true" class="in show modal fade planilhasPreventivas" role="dialog">
    <div class="modal-dialog" role="document">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>
          <h3 class="modal-title">Planilhas de Preventivas </h3>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-center align-items-center">
            <div class="text-center">
              <label class="form-label" for="bienio">Selecione os anos que deseja baixar:</label>
              <select  class="form-select" v-model="bienio">
                <!-- <option v-for="b in bienios" :key="b" :value="b">{{ typeof(b) == 'string' ? b.replace('_', '/') : '' }}</option> -->
                <option v-for="b in bienios" :key="b" :value="b">{{ b.replace('_', '/') }}</option>
              </select>
            </div>
            <div class="text-center">
              <button id="button" class="btn-primary" @click="selecionar()">Selecionar</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
      return {
        bienio: '2022_2023'
        // bienios: []
      }
    },
    computed: {
      bienios () {
        let bienios = []
        let dataAtual = new Date()
        let anoAtual = dataAtual.getFullYear()
        /* Cria um array com dois anos consecutivos, a partir do ano corrente até 2020, e adciona ao array bienios */
        for (let i = anoAtual; i >= 2020; i -= 2) {
          let x = `${i - 1}_${i}`
          bienios.push(x)
        }
        return bienios
      }
    },
    components: {
    },
    methods: {
      fecharModal: function () {
        this.$store.commit('setPlanilhasPreventivas', {conteudo: null, show: false})
      },
      selecionar () {
        this.$emit('selecionado', this.bienio)
        this.fecharModal()
      }
    }
  }
  </script>

  <style scoped>
  .planilhasPreventivas {
    transition: 1s;
    overflow: auto;
  }
  /* .existeEvidencia{
    display: block;
  }
  fieldset.schedule-border {
      border: 1px groove #ddd !important;
      padding: 0 1.4em 1.4em 1.4em !important;
      margin: 0 0 1.5em 0;
      -webkit-box-shadow: 0px 0px 0px 0px #000;
      box-shadow: 0px 0px 0px 0px #000;
  }
  legend.schedule-border {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      width: inherit;
      padding: 0 10px;
      border-bottom: none;
  } */
  fieldset {
    font-size: 1.1em;
    padding: 20px;
    margin-top: 50px;
    border: 1px solid silver;
  }
  .input-border{
    margin-bottom: 20px;
  }
  #button {
    margin-top: 5px;
  }
  .modal-dialog {
    width: 25%;
  }
  .modal {
    z-index: 99990;
  }
  .modal-header {
    background-color: #3b8dbc;
    text-align: center;
    color: #FFFF;
  }
  .modal-body {
      position: relative;
      margin-bottom: 1.94em;
  }
  .modal-footer {
      padding: 14px 37px;
      text-align: right;
      border-top: 1px solid #e5e5e5;
  }
  label{
    margin-top: 5px;
  }
  .btn-fechar {
    margin-right: 0.5em;
  }
  </style>



// WEBPACK FOOTER //
// PlanilhasPreventivas.vue?6045d67e